export default __webpack_public_path__ + "static/media/K_logo02.2571f66c.png";